import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import LoadingAnimation from './LoadingAnimation';
import { getImageAsBase64Url } from '../utils/httpHelpers';

const SecureImage = ({ src, intl, onError, ...other }) => {
  const [loading, setLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState(null);

  const [error, setError] = useState(null);

  useEffect(() => {
    setError(null);
    if (!src) {
      setImgUrl(null);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    let mounted = true;

    getImageAsBase64Url(src, intl)
      .then(url => {
        if (mounted) {
          setImgUrl(url);
        }
      })
      .catch(setError)
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [src, intl]);
  useEffect(() => {
    if (error && typeof onError === 'function') {
      onError(error);
      setError(null);
    }
  }, [error, onError]);

  if (loading) return <LoadingAnimation />;
  if (!imgUrl) return null;
  return <img {...other} src={imgUrl} onError={setError} />;
};

SecureImage.propTypes = {
  src: PropTypes.string,
  intl: intlShape.isRequired,
  onError: PropTypes.func,
};
SecureImage.defaultProps = {
  src: '',
  onError: undefined,
};

export default injectIntl(SecureImage);
